import {toast} from 'react-toastify';

// Operations the tech team has yet to ship are rejected by name at the
// gateway. Screens built ahead of them say so in plain words.
export const notDeployed = message =>
  /Cannot query field|Unknown type|Unknown argument/.test(message || '');

// What an editor sees when a page can't load. The raw error goes to the
// console for the tech team, never to the screen.
export const loadError = (what, err) => {
  if (err) console.error(err);
  if (notDeployed(err?.message)) {
    return `We can't show ${what} here yet. The tech team is still adding it.`;
  }
  return `We couldn't load ${what}. Refresh the page, and tell the tech team if it keeps happening.`;
};

// The same for an action that failed: a toast in words, the detail in the console.
export const actionError = what => err => {
  console.error(err);
  toast.error(
    notDeployed(err?.message)
      ? `You can't ${what} from here yet. The tech team is still adding it.`
      : `We couldn't ${what}. Try again, and tell the tech team if it keeps happening.`,
  );
};

// A union result of type Error, told the same way.
export const unionError = (what, payload) => {
  console.error(payload?.message);
  toast.error(
    `We couldn't ${what}. Try again, and tell the tech team if it keeps happening.`,
  );
};
